import type { StateCreator } from 'zustand'

import { persist } from 'zustand/middleware'
import { createWithEqualityFn as create } from 'zustand/traditional'

export type TableConfigState = {
	columnVisibility: Record<string, boolean>
	columnPinning: { left?: string[]; right?: string[] }
	columnOrder: string[]
	columnSizing: Record<string, number>
	setColumnVisibility: (
		modifier: (state: Record<string, boolean>) => Record<string, boolean>
	) => void
	setColumnPinning: (
		modifier: (state: { left?: string[]; right?: string[] }) => {
			left?: string[]
			right?: string[]
		}
	) => void
	setColumnOrder: (columnOrder: string[]) => void
	setColumnSizing: (
		modifier: (state: Record<string, number>) => Record<string, number>
	) => void
}

const definition: StateCreator<TableConfigState> = (setState) =>
	({
		columnVisibility: {},
		columnPinning: { left: [], right: [] },
		columnOrder: [],
		columnSizing: {},
		setColumnVisibility: (modifier) =>
			setState((state) => ({
				...state,
				columnVisibility: modifier(state.columnVisibility),
			})),
		setColumnPinning: (modifier) =>
			setState((state) => ({
				...state,
				columnPinning: modifier(state.columnPinning),
			})),
		setColumnOrder: (columnOrder) =>
			setState((state) => ({
				...state,
				columnOrder,
			})),
		setColumnSizing: (modifier) =>
			setState((state) => ({
				...state,
				columnSizing: modifier(state.columnSizing),
			})),
	}) as TableConfigState

export const useAssortmentTableConfigStore = create<
	TableConfigState,
	[['zustand/persist', TableConfigState]]
>(
	persist(definition, {
		name: 'assortment_table_config',
		version: 1,
	})
)
export const useProductsTableConfigStore = create<
	TableConfigState,
	[['zustand/persist', TableConfigState]]
>(
	persist(definition, {
		name: 'products_table_config',
		version: 1,
	})
)
export const useAnchorsTableConfigStore = create<
	TableConfigState,
	[['zustand/persist', TableConfigState]]
>(
	persist(definition, {
		name: 'anchors_table_config',
		version: 1,
	})
)
